Vue.asyncComponent('ak-localization-button', {
    props: {
        locales: {
            type: Array|String,
            required: false,
        },
        activeLocales: {
            type: Array|String,
            required: false,
        }
    },
    methods: {
        isActive(locale) {
            return this.activeLocales && this.activeLocales.includes(locale);
        },
        localeItemClicked(locale) {
            this.$emit('click', locale);
        }
    }
}, 'locale/ak-localization-button.html');
